import { Link, useNavigate } from "react-router-dom";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import {
  AppBar,
  AppBarProps,
  IconButton,
  Toolbar,
  Tooltip,
  styled,
} from "@mui/material";
import { useAppContext } from "../../context/AppContext";

export interface HeadProps extends AppBarProps {
  allowBack?: boolean;
  titleContent?: ReactNode;
}

const StyledImage = styled("img")(({ theme }) => ({
  height: theme.spacing(4),
  lineHeight: 0,
  display: "inline-block",
}));

export const Head: React.FC<HeadProps> = ({
  allowBack,
  titleContent,
  ...appBarProps
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { toggleSettingsDialog } = useAppContext();

  return (
    <>
      <AppBar {...appBarProps}>
        <Toolbar>
          <Grid container alignItems="center" flexGrow={1}>
            <Grid xs={2} alignItems="center" display="flex">
              <IconButton
                color="inherit"
                edge="start"
                onClick={() => navigate("/protected/all-patients")}
                sx={{
                  display: {
                    xs: allowBack ? "inline-flex" : "none",
                    md: "none",
                  },
                }}
              >
                <ArrowBackIcon />
              </IconButton>
              <IconButton
                component={Link}
                size="small"
                to="/protected/all-patients"
                sx={{
                  display: {
                    xs: allowBack ? "none" : "inline-flex",
                    md: "inline-flex",
                  },
                }}
              >
                <StyledImage
                  src={`${import.meta.env.BASE_URL}/robin-logo.png`}
                  alt="RZ"
                />
              </IconButton>
            </Grid>
            <Grid alignItems="center" display="flex" justifyContent="center" xs>
              {titleContent}
            </Grid>
            <Grid
              xs={2}
              alignItems="center"
              display="flex"
              justifyContent="flex-end"
            >
              <Tooltip title={t("settings.title")}>
                <IconButton color="inherit" onClick={toggleSettingsDialog}>
                  <SettingsOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  );
};
